const Dept = () => import(/* webpackChunkName: "syst" */ './dept/Index');
const Role = () => import(/* webpackChunkName: "syst" */ './role/Index');
const User = () => import(/* webpackChunkName: "syst" */ './user/Index');
const Api = () => import(/* webpackChunkName: "syst" */ './api/Index');
const Menu = () => import(/* webpackChunkName: "syst" */ './menu/Index');
const Func = () => import(/* webpackChunkName: "syst" */ './func/Index');
const LoginLog = () => import(/* webpackChunkName: "syst" */ './Logging/loginlog');
const LoginLogStatis = () => import(/* webpackChunkName: "syst" */ './Logging/loginlogstatis');
const Security = () => import('./security/Index');



export default {
  routes: [
    {
      path: '/syst/dept',
      name: 'syst_dept',
      component: Dept
    }, {
      path: '/syst/role',
      name: 'syst_role',
      component: Role
    }, {
      path: '/syst/user',
      name: 'syst_user',
      component: User
    }, {
      path: '/syst/api',
      name: 'syst_api',
      component: Api
    }, {
      path: '/syst/menu',
      name: 'syst_menu',
      component: Menu
    }, {
      path: '/syst/func',
      name: 'syst_func',
      component: Func
    },
    {
      path: '/log/loginlog',
      name: 'Log_loginlog',
      component: LoginLog
    },
    {
      path: '/log/loginlogstatis',
      name: 'Log_loginlogstatis',
      component: LoginLogStatis
    },
    {
      path: '/syst/security',
      name: 'Security',
      component: Security
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/syst/router.js